export default function AdminStatCard({ icon: Icon, label, value, color, sub }) {
  return (
    <div className="bg-white rounded-2xl border border-[#E8E6F8] shadow-sm p-5 flex items-center gap-4">
      <div
        className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
        style={{ backgroundColor: `${color}18` }}
      >
        <Icon className="h-5 w-5" style={{ color }} />
      </div>
      <div className="min-w-0">
        <p className="text-2xl font-heading font-bold text-[#1A1A2E] leading-tight">{value ?? 0}</p>
        <p className="text-xs text-[#6B7280] font-body mt-0.5">{label}</p>
        {sub && <p className="text-[10px] text-[#9CA3AF] font-body mt-0.5">{sub}</p>}
      </div>
    </div>
  );
}
